import { getPeriodDateRangeValues, periodDateRangeDeserializer } from '@/core/ui';
import { appSessionStorage, createAppAsyncThunk } from '@/warehouse/helpers';
import { getDatesFromStoredValue } from '@/core/ui/StoredPeriodDateRange/helpers';
import { formatDateForApiRequest } from '@/core/utils/datetime';
import { stockReceiptApi } from '@/warehouse/modules/stockReceipt/business';
import { invoicesDefaultPeriodDateRange } from '@/warehouse/modules/stockReceipt/constants';
/**
 * This workflow is needed to initiate **picked** picking tasks request to have `pickedTaskCount` counter defined even
 * if tab's data is not necessary to be loaded, since it is not shown.
 */
const initInvoices = createAppAsyncThunk('stockReceipt/initInvoices', async (_, { dispatch, rejectWithValue, fulfillWithValue }) => {
    const defaultPeriodDateRangeValues = {
        period: invoicesDefaultPeriodDateRange,
        ...getPeriodDateRangeValues(invoicesDefaultPeriodDateRange),
    };
    const storedPeriod = appSessionStorage.getDeserializedItem('warehouseStockReceiptPeriodFilter', defaultPeriodDateRangeValues, {
        deserializer: periodDateRangeDeserializer,
    });
    const rangeValues = getDatesFromStoredValue(storedPeriod);
    try {
        await dispatch(stockReceiptApi.endpoints.getStockInvoices.initiate({
            article: '',
            isReceipted: true,
            dateFrom: rangeValues.dateFrom ? formatDateForApiRequest(rangeValues.dateFrom) : '',
            dateTo: rangeValues.dateTo ? formatDateForApiRequest(rangeValues.dateTo) : '',
        })).unwrap();
        return fulfillWithValue({ success: true });
    }
    catch (error) {
        // TODO: add log to backend
        console.error(`In initInvoices() -> getStockInvoices() api request error:`, error);
        if (error instanceof Error) {
            return rejectWithValue(`In initInvoices() -> getStockInvoices() api request failed with message: ${error.message}`);
        }
        return rejectWithValue('Server unexpected error');
    }
});
export { initInvoices };
